import { render, staticRenderFns } from "./i-map.vue?vue&type=template&id=716e926c&scoped=true&"
import script from "./i-map.vue?vue&type=script&lang=js&"
export * from "./i-map.vue?vue&type=script&lang=js&"
import style0 from "./i-map.vue?vue&type=style&index=0&id=716e926c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e926c",
  null
  
)

export default component.exports